import { SortWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Sort')
export class SortNodeSchemaProvider extends SchemaProvider<SortWorkflowNode> {}
